import { render, staticRenderFns } from "./FollowupsFilterPopover.vue?vue&type=template&id=16ef15f0&scoped=true"
import script from "./FollowupsFilterPopover.vue?vue&type=script&lang=js"
export * from "./FollowupsFilterPopover.vue?vue&type=script&lang=js"
import style0 from "./FollowupsFilterPopover.vue?vue&type=style&index=0&id=16ef15f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef15f0",
  null
  
)

export default component.exports